<script setup>
import { shared } from './shared.js'
</script>

<template>
    <!-- Control modal -->
    <div class="modal modal-lg fade" id="controlModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Control</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h6>Target</h6>
                    <select v-model="target" class="form-select">
                        <option value="client">Client</option>
                        <option value="acsa" v-if="checkIfTargetIsApplicable('acsa')">ACSA</option>
                        <option value="aboard" v-if="checkIfTargetIsApplicable('aboard')">Aboard</option>
                        <option value="bms" v-if="checkIfTargetIsApplicable('bms')">BMS</option>
                        <option value="inrec" v-if="checkIfTargetIsApplicable('inrec')">InREC</option>
                        <option :value="'inrec_' + index" v-for="index in deviceDetail.inrecs_in_cluster">InREC ({{
                            index }})</option>
                    </select>
                    <hr>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#control-params"
                                type="button">Parameters</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#control-reset"
                                type="button">Reset</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#control-firmware-update"
                                type="button">Firmware update</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#control-debug-dac"
                                type="button">DAC</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" data-bs-toggle="tab" data-bs-target="#control-debug-watchpoints"
                                type="button">Watchpoints</button>
                        </li>
                    </ul>
                    <br>
                    <div class="tab-content">
                        <div class="tab-pane show active" id="control-params">
                            <div class="mb-3" v-if="target == 'client'">
                                <div class="alert alert-info" role="alert">
                                    Parameter writing is not possible with target 'client'
                                </div>
                            </div>
                            <div class="mb-3" v-else>
                                <div class="mb-3">
                                    <button type="button" class="btn btn-info" @click="unlockService()"
                                        style="margin-right: 1em;">Unlock service</button>
                                    <button type="button" class="btn btn-warning" @click="unlockFactory()">Unlock
                                        factory</button>
                                </div>
                                <hr />
                                <label class="form-label">Parameter</label>
                                <SimpleTypeahead class="form-control" placeholder="Parameter"
                                    @selectItem="onParameterSelectItem" @onInput="onParameterInput"
                                    @onBlur="onParameterBlur"
                                    v-if="deviceDetail && deviceDetail[target] && deviceDetail[target].config"
                                    :items="Object.keys(flatten_and_filter(deviceDetail[target].config))">
                                </SimpleTypeahead>
                                <input v-else class="form-control" v-model="parameter" placeholder="Parameter" />
                                <br />
                                <label class="form-label" style="margin-right: 2em;">Current value (from
                                    config):</label>
                                <label class="fw-bold form-label">{{ getLatestParamterValueFromConfig }}</label>
                                <br />
                                <label class="form-label">New value</label>
                                <input class="form-control" v-model="value" placeholder="New value" />
                                <br />
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" v-model="read_config_after_write">
                                    <label class="form-label">Read config after write</label>
                                </div>
                                <hr />
                                <button type="button" class="btn btn-primary" @click="writeParameter()">Write
                                    parameter</button>
                            </div>
                        </div>
                        <div class="tab-pane show" id="control-reset">
                            <div class="mb-3">
                                <button type="button" class="btn btn-info" @click="softwareReset()">Soft reset</button>
                                <span v-if="target != 'client'">
                                    <br /><br />
                                    <div class="alert alert-danger" role="alert">
                                        The following actions are <b>irreversible</b>, use with extreme caution!
                                    </div>
                                    <button type="button" class="btn btn-danger" @click="userDefaults()">User
                                        defaults</button>
                                    <br /><br />
                                    <button type="button" class="btn btn-danger" @click="factoryDefaults()">Factory
                                        defaults</button>
                                </span>
                            </div>
                        </div>
                        <div class="tab-pane show" id="control-firmware-update">
                            <div class="mb-3" v-if="target == 'client'">
                                <div class="alert alert-info" role="alert">
                                    Firmware updating is not possible with target 'client'
                                </div>
                            </div>
                            <div class="mb-3" v-else>
                                <label class="form-label">Project</label>
                                <select v-model="firmware_project_versions" class="form-select">
                                    <option :value="value" v-for="(value, name, index) in shared.firmware_versions">{{
                                        name }}</option>
                                </select>
                                <br />
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" v-model="filter_final_releases">
                                    <label class="form-label">Show only final releases</label>
                                </div>
                                <br />
                                <select v-model="version" class="form-select">
                                    <option v-for="version in filteredProjectVersions">{{ version }}</option>
                                </select>
                                <hr />
                                <input class="form-control" v-model="version" placeholder="Manual version input"
                                    autocomplete="on" name="firmware_version" />
                                <hr />
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" v-model="force_byte_swap">
                                    <label class="form-label">Force byte-swap</label>
                                </div>
                                <hr />
                                <button type="button" class="btn btn-warning" @click="updateFirmware()">Update
                                    firmware</button>
                            </div>
                        </div>
                        <div class="tab-pane show" id="control-debug-dac">
                            <div class="mb-3" v-if="target == 'client'">
                                <div class="alert alert-info" role="alert">
                                    Debug DAC is not applicable with target 'client'
                                </div>
                            </div>
                            <div class="mb-3" v-else-if="!deviceDetail[target].config.debug">
                                <div class="alert alert-warning" role="alert">
                                    Debug data not available. Check if client has 'include_debug_parameters' config
                                </div>
                            </div>
                            <div class="mb-3" v-else>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style="width:50px"></th>
                                            <th>Address</th>
                                            <th>Type</th>
                                            <th>Gain</th>
                                            <th>Offset</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in deviceDetail[target].config.debug.dac">
                                            <td>{{ index }}</td>
                                            <td><input class="form-control form-control-sm" v-model="item.address" />
                                            </td>
                                            <td>
                                                <select v-model="item.type" class="form-select form-select-sm">
                                                    <option value="0">0: float</option>
                                                    <option value="1">1: int32</option>
                                                    <option value="2">2: uint32</option>
                                                    <option value="3">3: int16</option>
                                                    <option value="4">4: uint16</option>
                                                </select>
                                            </td>
                                            <td><input class="form-control form-control-sm" v-model="item.gain" /></td>
                                            <td><input class="form-control form-control-sm" v-model="item.offset" /></td>
                                            <td><button type="button" class="btn btn-primary btn-sm" @click="writeDebugDacChannel(index, item.address, item.type, item.gain, item.offset)">Write</button></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td><button type="button" class="btn btn-warning btn-sm" @click="readConfig()">Read</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="tab-pane show" id="control-debug-watchpoints">
                            <div class="mb-3" v-if="target == 'client'">
                                <div class="alert alert-info" role="alert">
                                    Debug watchpoints are not applicable with target 'client'
                                </div>
                            </div>
                            <div class="mb-3" v-else-if="!deviceDetail[target].config.debug || !deviceDetail[target].data_quick.debug">
                                <div class="alert alert-warning" role="alert">
                                    Debug data not available. Check if client has 'include_debug_parameters' config
                                </div>
                            </div>
                            <div class="mb-3" v-else>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style="width:50px"></th>
                                            <th>Address</th>
                                            <th style="width:50px"></th>
                                            <th>Type</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in deviceDetail[target].config.debug.watchpoints">
                                            <td>{{ index }}</td>
                                            <td><input class="form-control form-control-sm" v-model="item.address" /></td>
                                            <td><button type="button" class="btn btn-primary btn-sm" @click="writeDebugWatchpointsChannel(index, item.address)">Write</button></td>
                                            <td>
                                                <select v-model="debug_watchpoints_types[index]" class="form-select form-select-sm">
                                                    <option value="uint32">uint32</option>
                                                    <option value="int32">int32</option>
                                                    <option value="float">float</option>
                                                    <option value="hex">hex</option>
                                                </select>
                                            </td>
                                            <td><input class="form-control form-control-sm" readonly :value="getDebugWatchpoint(index)" /></td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td><button type="button" class="btn btn-warning btn-sm" @click="readConfig()">Read</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['deviceDetail', 'client'],
    setup(props) {

    },
    data() {
        return {
            target: "client",
            parameter: "",
            value: "",
            version: "",
            force_byte_swap: false,
            read_config_after_write: false,

            firmware_project_versions: [],
            filter_final_releases: false,

            debug_watchpoints_types: {
                "ch1": "uint32",
                "ch2": "uint32",
                "ch3": "uint32",
                "ch4": "uint32",
                "ch5": "uint32",
                "ch6": "uint32",
                "ch7": "uint32",
                "ch8": "uint32",
            }
        };
    },
    watch: {
        deviceDetail: function (newVal, oldVal) {
            // Reset config target
            this.target = "client";
        }
    },
    computed: {
        filteredProjectVersions() {
            return this.firmware_project_versions.filter(version => (!this.filter_final_releases || version.match(/v-(([0-9])+(\.){0,1})+$/)))
        },
        getLatestParamterValueFromConfig() {
            let val = ""
            if (this.deviceDetail && this.deviceDetail[this.target] && this.deviceDetail[this.target].config) {
                val = shared.get_nested_value_safely(this.deviceDetail[this.target].config, this.parameter)
            }
            if (val == "-" || typeof val == "object") {
                val = ""
            }
            return val
        }
    },
    methods: {
        checkIfTargetIsApplicable(target) {
            return (this.deviceDetail.info && this.deviceDetail.info.devices && this.deviceDetail.info.devices[target]);
        },
        sendRequest(requestFunction) {
            if (this.deviceDetail != null) {
                var topic = this.deviceDetail.topic_base + "/" + this.deviceDetail.serial + "/request"
                var payload = {
                    function: requestFunction,
                    target: this.target
                }

                this.client.publish(topic, JSON.stringify(payload), error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            }
        },
        userDefaults() { this.sendRequest('user_default') },
        factoryDefaults() { this.sendRequest('factory_default') },
        softwareReset() { this.sendRequest('software_reset') },
        unlockService() { this.sendRequest('unlock_service') },
        unlockFactory() { this.sendRequest('unlock_factory') },

        readConfig() {
            if (this.deviceDetail != null) {
                var topic = this.deviceDetail.topic_base + "/" + this.deviceDetail.serial + "/request"
                var payload = {
                    function: "read_config",
                    target: this.target,
                }
                this.client.publish(topic, JSON.stringify(payload), error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            }
        },

        writeParameterValue(target, parameter, value) {
            let topic = this.deviceDetail.topic_base + "/" + this.deviceDetail.serial + "/request"
            let payload = {
                function: "write_parameter",
                target: target,
                parameter: parameter,
                value: value,
            }

            this.client.publish(topic, JSON.stringify(payload), error => {
                if (error) {
                    console.log('Publish error', error)
                }
            })
        },

        writeParameter() {
            if (this.deviceDetail != null) {
                this.writeParameterValue(this.target, this.parameter, this.value)

                if (this.read_config_after_write) {
                    this.readConfig()
                }
            }
        },
        updateFirmware() {
            if (this.deviceDetail != null) {
                var topic = this.deviceDetail.topic_base + "/" + this.deviceDetail.serial + "/request"
                var payload = {}
                if (this.force_byte_swap) {
                    payload = {
                        function: "update_firmware",
                        target: this.target,
                        version: this.version,
                        force_byte_swap: true,
                    }
                } else {
                    payload = {
                        function: "update_firmware",
                        target: this.target,
                        version: this.version,
                    }
                }

                this.client.publish(topic, JSON.stringify(payload), error => {
                    if (error) {
                        console.log('Publish error', error)
                    }
                })
            }
        },
        flatten_and_filter(data) {
            var result = {};
            function recurse(cur, prop) {
                if (Object(cur) !== cur) {
                    if (prop.endsWith("*") == false) {
                        result[prop] = cur;
                    }
                } else if (Array.isArray(cur)) {
                    for (var i = 0, l = cur.length; i < l; i++)
                        recurse(cur[i], prop + "[" + i + "]");
                    if (l == 0)
                        result[prop] = [];
                } else {
                    var isEmpty = true;
                    for (var p in cur) {
                        isEmpty = false;
                        recurse(cur[p], prop ? prop + "." + p : p);
                    }
                    if (isEmpty && prop)
                        result[prop] = {};
                }
            }
            recurse(data, "");
            return result;
        },

        onParameterSelectItem(item) {
            this.parameter = item;
        },
        onParameterInput(event) {
            this.parameter = event.input;
        },
        onParameterBlur(event) {
            this.parameter = event.input;
        },

        // Debug DAC
        writeDebugDacChannel(ch, address, type, gain, offset) {
            this.writeParameterValue(this.target,  "debug.dac." + ch + ".address", address)
            this.writeParameterValue(this.target,  "debug.dac." + ch + ".type", type)
            this.writeParameterValue(this.target,  "debug.dac." + ch + ".gain", gain)
            this.writeParameterValue(this.target,  "debug.dac." + ch + ".offset", offset)
        },

        // Debug watchpoints
        writeDebugWatchpointsChannel(ch, address) {
            this.writeParameterValue(this.target,  "debug.watchpoints." + ch + ".address", address)
        },
        getDebugWatchpoint(ch) {
            let target_type = this.debug_watchpoints_types[ch]
            let value = shared.get_nested_value_safely(this.deviceDetail[this.target].data_quick, "debug.watchpoints." + ch + ".data")
            
            const dv = new DataView(new ArrayBuffer(4));
            dv.setUint32(0, value);
            if (target_type == "int32") {
                value = dv.getInt32(0);
            } else if (target_type == "float") {
                value = dv.getFloat32(0);
            } else if (target_type == "hex") {
                value = value.toString(16).toUpperCase();
                while (value.length < 8) {
                    value = "0" + value;
                }
                value = "0x" + value
            }
            return value     
        },
    },
};
</script>